// text-field.tsx
import { FC, useState } from 'react';
import styled from '@emotion/styled';

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 4px;
`;

export const Label = styled.label`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #6d6d6d;
`;

export const Control = styled.div`
  position: relative;
  width: 100%;
`;

export const Input = styled.input<{ hasToggle: boolean }>`
  width: 100%;
  padding: ${({ hasToggle }) => (hasToggle ? '14px 44px 14px 12px' : '10px 12px')};
  border: 1px solid #bfc8e6;
  border-radius: 9.42px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  outline: none;
  height: 48px;
  &:focus {
    border-color: #7a8ae6;
  }
`;

export const Toggle = styled.img<{ $active: boolean }>`
  position: absolute;
  top: 50%;
  right: 12px;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  cursor: pointer;
  user-select: none;
  opacity: ${({ $active }) => ($active ? 1 : 0.6)};
  z-index: 1;
`;

/* ── TextField component ── */

interface TextFieldProps {
  id: string;
  label?: string; // now optional
  type?: 'text' | 'password';
  value: string;
  onChange: (v: string) => void;
}

export const TextField: FC<TextFieldProps> = ({ id, label, type = 'text', value, onChange }) => {
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';

  return (
    <FieldWrapper>
      {label && <Label htmlFor={id}>{label}</Label>}

      <Control>
        <Input
          id={id}
          type={isPassword && show ? 'text' : type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          hasToggle={isPassword}
        />

        {isPassword && (
          <Toggle
            $active={show}
            src={show ? '/icons/eye-open.png' : '/icons/eye-closed.png'}
            alt={show ? 'Hide password' : 'Show password'}
            onClick={() => setShow((s) => !s)}
          />
        )}
      </Control>
    </FieldWrapper>
  );
};
